module.exports = __webpack_public_path__ + "img/banner_operator_2.dd2508fc.png";